const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

const scheduleController = '/v1/chronique';

export const ScheduleServiceCommand: any = {
    //startSchedule: Backofficebff + scheduleController + '/get-recurring-job',
    //pauseSchedule: Backofficebff  + scheduleController + '/get-recurring-job',
    runSchedule: Backofficebff + scheduleController + '/fire-recurring-job',
    stopSchedule: Backofficebff + scheduleController + '/stop-recurring-job',
    resumeSchedule: Backofficebff + scheduleController + '/resume-recurring-job',
    deleteSchedule: Backofficebff + scheduleController + '/delete-recurring-job',
    createSchedule: Backofficebff + scheduleController + '/create-recurring-job',
    updateSchedule: Backofficebff + scheduleController + '/update-recurring-job',
};
